import axios from 'axios'
import Cookies from 'js-cookie'

// APIレスポンスのエラーハンドリング
export const setupApiInterceptor = () => {
  // レスポンスインターセプター
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      // Facebookトークンが無効な場合（トークン切れ）
      if (
        error.response?.status === 401 &&
        (error.response?.data?.error === 'FACEBOOK_TOKEN_INVALID' ||
          error.response?.data?.needsReauth === true)
      ) {
        // トークンをクリアしてログインページへ
        Cookies.remove('token')

        if (typeof window !== 'undefined') {
          const currentPath = window.location.pathname
          // 既にログインページにいる場合はリダイレクトしない
          if (!currentPath.includes('/login')) {
            window.location.href = '/login'
          }
        }
      }

      return Promise.reject(error)
    },
  )
}

// アプリケーション起動時に手動で初期化する必要がある
// _app.js内で setupApiInterceptor() を呼ぶ
